import React, { useState, useEffect, useMemo } from 'react';
import { Autocomplete, TextField } from '@mui/material';

const defaultGetOptionLabel = (option) => {
  if (!option) return '';
  return typeof option === 'string' ? option : option.label || '';
};

const SearchableSingleSelect = ({
  label,
  options,
  value,
  onChange,
  error,
  helperText,
  required,
  getOptionLabel,
  isOptionEqualToValue,
  placeholder,
  disabled
}) => {
  const [inputValue, setInputValue] = useState('');

  const labelGetter = useMemo(
    () => getOptionLabel || defaultGetOptionLabel,
    [getOptionLabel]
  );

  useEffect(() => {
    setInputValue(labelGetter(value));
  }, [value, labelGetter]);

  return (
    <Autocomplete
      options={options}
      value={value || null}
      onChange={(event, newValue) => {
        onChange({ target: { value: newValue } });
        setInputValue(labelGetter(newValue));
      }}
      onInputChange={(event, newInputValue, reason) => {
        if (reason === 'input') {
          setInputValue(newInputValue);
        } else if (reason === 'clear') {
          setInputValue('');
        }
      }}
      getOptionLabel={labelGetter}
      inputValue={inputValue}
      isOptionEqualToValue={
        isOptionEqualToValue || ((option, val) => option?.value === val?.value)
      }
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          required={required}
          InputLabelProps={{
            shrink: true,
          }}
        />
      )}
      ListboxProps={{
        style: {
          maxHeight: 250,
        },
      }}
      sx={{
        '& .MuiAutocomplete-inputRoot': {
          paddingTop: '16.5px',
          paddingBottom: '16.5px',
        },
        '& .MuiAutocomplete-input': {
          padding: '0 !important',
        },
      }}
    />
  );
};

export default SearchableSingleSelect;